import React from 'react'
import { colors } from 'src/assets/colors'
import { AbstractButton, IButtonProps } from './AbstractButton'

export const PrimaryButton = (props: IButtonProps) => (
  <AbstractButton
    loading={props.loading}
    disabled={props.disabled}
    shadow={props.shadow}
    onPress={props.onPress}
    title={props.title}
    testID={props.testID}
    subtitle={props.subtitle}
    textColor={colors.textLight}
    backgroundColor={props.disabled ? colors.selectedBlueDisabled : colors.selectedBlue}
    paddingHorizontal={props.paddingHorizontal}
  />
)
